import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function StatCard({
  label,
  value,
  delta,
  trend = "up",
  suffix,
  prefix,
  accent = "indigo",
  icon: Icon,
  testId,
  size = "md",
}) {
  const accentBg = {
    indigo: "from-indigo-500/20 to-transparent",
    cyan:   "from-cyan-400/20 to-transparent",
    amber:  "from-amber-400/20 to-transparent",
    pink:   "from-pink-400/15 to-transparent",
    emerald:"from-emerald-400/15 to-transparent",
  }[accent];

  const iconColor = {
    indigo: "text-indigo-300",
    cyan:   "text-cyan-300",
    amber:  "text-amber-300",
    pink:   "text-pink-300",
    emerald:"text-emerald-300",
  }[accent];

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
      data-testid={testId}
      className="glass-card relative overflow-hidden p-5"
    >
      <div className={cn("absolute inset-0 bg-gradient-to-br opacity-70 pointer-events-none", accentBg)} />
      <div className="relative flex items-start justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-[0.14em] text-white/50 font-mono">
            {label}
          </div>
          <div className={cn(
            "mt-2 font-mono font-semibold text-white leading-none",
            size === "lg" ? "text-4xl" : "text-3xl"
          )}>
            {prefix}
            {value}
            {suffix && <span className="text-white/50 text-lg ml-0.5">{suffix}</span>}
          </div>
          {delta && (
            <div className={cn(
              "mt-3 inline-flex items-center gap-1 text-[11.5px] font-mono",
              trend === "up" ? "text-emerald-400" : "text-red-400"
            )}>
              {trend === "up" ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
              {delta}
            </div>
          )}
        </div>
        {Icon && (
          <div className={cn("h-9 w-9 rounded-lg bg-white/[0.03] border border-white/[0.06] grid place-items-center", iconColor)}>
            <Icon className="h-4 w-4" strokeWidth={2} />
          </div>
        )}
      </div>
    </motion.div>
  );
}
